"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerDiv = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
exports.ContainerDiv = styled_1.default.ul `
    display: flex;
    scroll-snap-type: x mandatory;
    overflow-x: auto;
    overflow-y: hidden;
    max-width: 100%;

    &.maximize-width{
      width: 100%;
    }

    &.fit-width{
      width: fit-content;
    }

    ::-webkit-scrollbar {
      display: none;
    }

    *{
      scroll-snap-align: start;
    }

    @media (min-width: 320px){
      scroll-padding: ${(props) => (props === null || props === void 0 ? void 0 : props.scrollPaddingMobile) ? props.scrollPaddingMobile : "0 16px"};
      column-gap: ${(props) => (props === null || props === void 0 ? void 0 : props.columnGapMobile) ? props.columnGapMobile : "16px"};
    }

    @media (min-width: 768px){
      scroll-padding: 0 ${(props) => (props === null || props === void 0 ? void 0 : props.scrollPaddingTablet) ? props.scrollPaddingTablet : "32px"};
      column-gap: ${(props) => (props === null || props === void 0 ? void 0 : props.columnGapTablet) ? props.columnGapTablet : "32px"};
    }

    @media (min-width: 1280px){
      justify-content: center;
      scroll-padding: 0 ${(props) => (props === null || props === void 0 ? void 0 : props.scrollPaddingDesktop) ? props.scrollPaddingDesktop : "124px"};
      column-gap: ${(props) => (props === null || props === void 0 ? void 0 : props.columnGapDesktop) ? props.columnGapDesktop : "32px"};
    }
`;
